
import { SiriusBaseComponent } from 'sirius-framework';
import { Component } from '@angular/core';

@Component({
    selector: 'inner-menu-account',
    templateUrl: './inner-menu-account.component.html',
    styleUrls: ['./inner-menu-account.component.css']
})
export class InnerMenuAccountComponent extends SiriusBaseComponent<any> {
    constructor() {
        super();
    }
    OnInit() {

    }
}
